import createVueComponent from '../createVueComponent';

const Tally3 = createVueComponent('Tally3Icon', [
  ['path', { d: 'M4 4v16', key: '6qkkli' }],
  ['path', { d: 'M9 4v16', key: '81ygyz' }],
  ['path', { d: 'M14 4v16', key: '12vmem' }],
]);

export default Tally3;
